import React, { useContext } from "react";

import "./services.css";
import Card from "../Card/Card";
import { themeContext } from "../../Context";

import { motion } from "framer-motion";

const Services = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  const transition = {
    duration: 1,
    type: "spring",
  };

  return (
    <div className="services">
      <div className="awesome">
        <span style={{ color: darkMode ? "white" : "" }}>My Education &</span>
        <span>Certificates</span>
        <span style={{ color: darkMode ? "white" : "" }}>
          <ul style={{ marginTop: "2rem" }}>
            <li style={{ marginTop: "2rem", fontSize: "1.5rem" }}>
              {" "}
              Jamia Millia Islamia (2020-2024)
            </li>
            <li style={{ marginTop: "2rem", fontSize: "1.5rem" }}>
              {" "}
              Class-XII CBSE(2019)
            </li>
            <li style={{ marginTop: "2rem", fontSize: "1.5rem" }}>
              {" "}
              Class-X CBSE(2017)
            </li>
          </ul>
        </span>
        <div className="blur s-blur1" style={{ background: "#ABF1FF94" }}></div>
      </div>

      <div className="cards">
        {/* <div style={{ ,left: "8rem" }}> */}
        <motion.div
          initial={{ left: "5rem",top:"20rem" }}
          whileInView={{ left: "4rem", top: "25rem" }}
          transition={transition}
        >
          <Card
            
            heading={"Data Science"}
          
            detail={
              " Aws Machine Learning Foundations(Scholarship), AI For Everyone "
            }
          />
        </motion.div>

        <motion.div
          initial={{ left: "20rem", top: "12rem" }}
          whileInView={{ left: "18rem" }}
          transition={transition}
        >
          {/* <div style={{ top: "12rem", left: "-30rem" }}> */}
          <Card
            
            heading={"Django"}
            detail={"Python and Django Full Stack Web Developer Bootcamp"}
          />
        </motion.div>

        <motion.div
          initial={{ top: "25rem", left: "-10rem" }}
          whileInView={{ left: "-18rem" }}
          transition={transition}
        >
          {/* <div style={{ top: "25rem", left: "-11rem" }}> */}
          <Card
           
            heading={"Google Cloud"}
            detail={"Google Cloud Programme"}
            color="rgba(252, 166, 31, 0.45)"
          />
        </motion.div>

        <div
          className="blur s-blur2"
          style={{ background: "var(--purple)" }}
        ></div>
      </div>
    </div>
  );
};

export default Services;
